import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function PasswordResetInjectors() {
  useInjectReducer({ key: "passwordReset", reducer });
  useInjectSaga({ key: "passwordReset", saga });
  return null;
}
